import React from 'react';
import MyScoutingsDatatable from "./components/datatable/MyScoutingsDatatable";
import rows from './components/ScoutingsRows';
import FilterToolbar from "../../../ui/filters/FilterToolbar";
import {Scouting} from "./FiltersConfig";
import ShareModal from "./components/modals/ShareModal";
import GenerateReportModal from "../../../ui/modals/GenerateReportModal";

class MyScoutings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: rows,
            shareModal: false,
        }
    }

    openShareModal = () => {
        this.setState({
            shareModal: true
        });
    }

    handleShareModalClose = () => {
        this.setState({
            shareModal: false
        })
    }

    filtersConfig = () => {
        return Scouting;
    };

    renderFilters = () => {
        const filters = this.filtersConfig();
        return <FilterToolbar filters={filters} size="sm" color="primary"/>;
    };

    render() {
        var showPagination = this.state.rows.length > 30;
        return (
            <div className="my-scoutings scoutings">
                {this.renderFilters()}
                <MyScoutingsDatatable
                    rows={JSON.parse(JSON.stringify(this.state.rows))}
                    showPagination={showPagination}
                    openShareModal={this.openShareModal}
                    openDownloadReportModal={() => this.toggleGenerateReportModal(true)}
                />
                <ShareModal show={this.state.shareModal} onHide={this.handleShareModalClose} />
                <GenerateReportModal
                    size="md-sm"
                    show={this.state.showGenerateReportModal}
                    onHide={() => this.toggleGenerateReportModal(false)}
                    headerTitle="Generate and Download Report"
                    headerSubtitle="Select report template and report file format"
                    onInputChange={console.log}
                />
            </div>
        )
    }

    toggleGenerateReportModal = (show) => {
        this.setState({
            showGenerateReportModal: show
        })
    }
}

export default MyScoutings;
